module.exports = __webpack_public_path__ + "static/dna_grey-bb0c0e0357bf7403dbadd9c6f526c238.png";